module.exports = __webpack_public_path__ + "img/product-img21.60823613.png";